export const fontQuicksand = (fs=1.2,lh=1.6, fw=5) => {
  return `
    font-size: ${fs}rem;
    line-height: ${lh}rem;
    font-weight: ${fw*100};
    font-family: "Quicksand", 'Helvetica','Arial','sans-serif';
  `
}